export default __webpack_public_path__ + "static/media/189.5c7f3ef6.jpg";